import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import * as classnames from 'classnames';
import { Box, Table, TableBody, TableContainer, TableRow, Typography, } from '@mui/material';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { show_sim_balance } from 'console//tabs/legacy/state/components/cards/gsm/show-sim-balance';
import { RadioSilenceCell } from './radiosilence-cell';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { DevicePermission } from 'console/device/device_ts';
import { CardTableCell } from '../../style/style-card';
import { useBilledSimState } from 'console/sim/utils/status';
import { useGetSimInDevice } from 'console/sim/utils/select-sim';
import { useNavigateTo } from 'shared/hooks/router';
import { FileTransfersTable } from 'console/utils/filetransfers-table';
const SimCell = memo(function SimCell(props) {
    const { sim_status } = props;
    const onClickOpenForeignSim = useCallbacks([
        preventDefault,
        useNavigateTo(`/sim/foreign/${sim_status.foreign_sim?.msisdn}`),
    ]);
    const onAddSim = useNavigateTo('/sim/add');
    const onClickOpenSimsDialog = useCallbacks([
        preventDefault,
        useNavigateTo(sim_status.billed_sim != null
            ? `/sim/billed/${sim_status.billed_sim.sim_card.id.id}/${sim_status.billed_sim.sim_card.id.operator}`
            : '/sim/list/'),
    ]);
    if (sim_status.billed_sim) {
        return (_jsxs(_Fragment, { children: [_jsxs(Typography, { noWrap: true, component: "span", children: [_jsx("span", { className: `sim-icon ${sim_status.billed_sim.sim_card.id.operator}` }), ' ', _jsxs("a", { onClick: onClickOpenSimsDialog, children: ["+", sim_status.billed_sim.sim_card.msisdn] })] }), _jsx("br", {}), _jsx(Box, { className: classnames({
                        'sim-warning': sim_status.warning,
                    }), sx: {
                        fontSize: sim_status.warning ? '100%' : '80%',
                        fontWeight: sim_status.warning ? 'normal' : undefined,
                    }, children: sim_status.billed_sim_state?.text })] }));
    }
    if (sim_status.foreign_sim) {
        return (_jsxs(Typography, { noWrap: true, component: "span", children: [_jsx("span", { className: "sim-icon unknown" }), ' ', _jsxs("a", { onClick: onClickOpenForeignSim, children: ["+", sim_status.foreign_sim.msisdn] })] }));
    }
    return _jsx("a", { onClick: onAddSim, children: "\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C" });
});
export function useGetSimStatus(device) {
    const [billed_sim, foreign_sim] = useGetSimInDevice(device?.id ?? -1);
    const [, billed_sim_state] = useBilledSimState(billed_sim?.sim_card.id.id, billed_sim?.sim_card.id.operator);
    return ENABLE_SIM &&
        LegacyDevice.has_capability(device?.capabilities ?? [], Capability.has_sim_in_device)
        ? {
            warning: billed_sim_state != null ? billed_sim_state.status != 'ok' : false,
            billed_sim,
            foreign_sim,
            billed_sim_state,
        }
        : {
            warning: false,
            billed_sim: null,
            foreign_sim: null,
            billed_sim_state: null,
        };
}
export const NetworkCard = memo(function NetworkCard(props) {
    const { account, r_device } = props;
    const sim_status = useGetSimStatus(r_device);
    if (!LegacyDevice.has_any_capability(r_device?.capabilities, [
        Capability.has_gsm,
        Capability.has_wifi,
    ])) {
        return null;
    }
    const { gsm_state, balance_value, radiosilence, radiosilence_planned } = r_device;
    const has_gsm = LegacyDevice.has_capability(r_device?.capabilities, Capability.has_gsm);
    const signal = gsm_state?.state !== 'not-registered' && gsm_state?.level
        ? parseInt(String(gsm_state?.level / 8), 10) + 1
        : 0;
    return (_jsxs(TableContainer, { className: classnames('ui-falarm-main-view-gsm', 'ui-card', {
            'ui-card-fail': sim_status.warning,
        }), children: [_jsx("div", { className: classnames('ui-card-icon ui-icon-zta-gsm-signal', `signal-${signal}`) }), _jsx("h1", { children: has_gsm ? 'GSM' : 'Wi-Fi' }), _jsx(Table, { children: _jsxs(TableBody, { children: [_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: has_gsm ? 'Оператор' : 'Сеть' }), _jsx(CardTableCell, { children: gsm_state?.operator })] }), LegacyDevice.has_capability(r_device?.capabilities, Capability.has_gsm_balance) &&
                            show_sim_balance(r_device.sim_in_device ?? null, r_device.user_id, account) && (_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u0411\u0430\u043B\u0430\u043D\u0441" }), _jsx(CardTableCell, { children: balance_value })] })), LegacyDevice.has_capability(r_device.capabilities, Capability.has_autoscan_settings) &&
                            r_device?.sim_number !== '' && (_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u041D\u043E\u043C\u0435\u0440" }), _jsx(CardTableCell, { children: r_device.sim_number })] })), LegacyDevice.has_capability(r_device?.capabilities, Capability.has_radiosilence) && (_jsxs(TableRow, { className: classnames({
                                warning: r_device.radiosilence === true,
                            }), children: [_jsx(CardTableCell, { component: "th", children: "\u0420\u0430\u0434\u0438\u043E\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u0435" }), _jsx(RadioSilenceCell, { device_id: r_device.id, enabled: LegacyDevice.has_access(account.id, r_device, DevicePermission.control), radio_silence: radiosilence, radio_silence_planned: radiosilence_planned })] })), r_device?.ethernet_state?.is_connected && (_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u0421\u0442\u0430\u0442\u0443\u0441 Ethernet" }), _jsx(CardTableCell, { children: r_device?.ethernet_state?.is_connected
                                        ? 'подключён'
                                        : 'отключён' })] })), ENABLE_SIM &&
                            LegacyDevice.has_capability(r_device.capabilities, Capability.has_sim_in_device) && (_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u0421\u0438\u043C-\u043A\u0430\u0440\u0442\u0430" }), _jsx(CardTableCell, { children: _jsx(SimCell, { sim_status: sim_status }) })] }))] }) }), _jsx("div", { className: "warning", children: _jsx(FileTransfersTable, { device_id: r_device.id, filetransfers: r_device.filetransfers }) })] }));
});
